export default "__VITE_ASSET__C1l1Pz7J__"